import { AppError } from './AppError';

/**
 * Raised for use-case coordination failures (e.g. a required dependency
 * was not correctly wired via the Composition Root).
 */
export class ApplicationError extends AppError {
  constructor(code: string, message: string, options?: { cause?: unknown }) {
    super(code, message, options);
    this.name = 'ApplicationError';
    Object.setPrototypeOf(this, ApplicationError.prototype);
  }
}
